import Loader from "@standard/components/BoxContainer/Loader";
import { DateService, NumberService } from "@standard/services";
import { DashboardAPI } from "api";
import { useEffect, useState } from "react";
import { JOB_STATUS, JobStatusComponent } from "data/jobStatus";

const $ = window.$;

function Dashboard() {
  const defaultData = {
    status: {
      waiting: 0,
      processing: 0,
      done: 0,
      complete: 0,
    },
    jobByStatus: [
      { status: "Waiting", total: 0 },
      { status: "Processing", total: 0 },
      { status: "Authening", total: 0 },
      { status: "Reject", total: 0 },
      { status: "Done", total: 0 },
      { status: "Complete", total: 0 },
    ],
    jobs: [],
  };

  const [data, setData] = useState(defaultData);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    DashboardAPI.getDashboard().then((dashboardData) => {
      setData((prev) => {
        return { ...prev, ...dashboardData };
      });

      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    $(document).ready(function () {
      activeDashboard();
    });
  }, [data]);

  const activeDashboard = () => {
    // var dataset = [
    //   {
    //     label: "Number of Jobs",
    //     data: data.jobs,
    //     color: "#1ab394",
    //     bars: {
    //       show: true,
    //       align: "center",
    //       barWidth: 24 * 60 * 60 * 600,
    //       lineWidth: 0,
    //     },
    //   },
    // ];
    // var options = {
    //   xaxis: {
    //     mode: "time",
    //     tickSize: [3, "day"],
    //     tickLength: 0,
    //     axisLabel: "Date",
    //     axisLabelUseCanvas: true,
    //     axisLabelFontSizePixels: 12,
    //     axisLabelFontFamily: "Arial",
    //     axisLabelPadding: 10,
    //     color: "#d5d5d5",
    //   },
    //   yaxes: [
    //     {
    //       position: "left",
    //       color: "#d5d5d5",
    //       axisLabelUseCanvas: true,
    //       axisLabelFontSizePixels: 12,
    //       axisLabelFontFamily: "Arial",
    //       axisLabelPadding: 10,
    //     },
    //     {
    //       position: "right",
    //       clolor: "#d5d5d5",
    //       axisLabelUseCanvas: true,
    //       axisLabelFontSizePixels: 12,
    //       axisLabelFontFamily: " Arial",
    //       axisLabelPadding: 67,
    //     },
    //   ],
    //   legend: {
    //     noColumns: 1,
    //     labelBoxBorderColor: "#000000",
    //     position: "nw",
    //   },
    //   grid: {
    //     hoverable: false,
    //     borderWidth: 0,
    //   },
    // };
    // $.plot($("#flot-dashboard-chart"), dataset, options);
    const pie_color = {
      waiting: "#f8ac59",
      processing: "#1c84c6",
      authening: "#23c6c8",
      reject: "#ed5565",
      done: "#1ab394",
      complete: "#d1dade",
    };

    var jobByStatus = data.jobByStatus.map((item) => {
      return {
        label: item.status,
        data: item.total,
        color: pie_color[item.status.toLocaleLowerCase()],
      };
    });

    $.plot("#flot-pie-chart", jobByStatus, {
      series: {
        pie: {
          show: true,
        },
      },
      grid: {
        hoverable: true,
      },
      tooltip: true,
      tooltipOpts: {
        content: function (label, x, y, serie) {
          const percent = Math.round(serie.datapoint[0]);

          return percent + "% (" + y + "), " + label;
        },
        shifts: {
          x: 20,
          y: 0,
        },
        defaultTheme: false,
      },
      label: {
        show: true,
      },
      legend: {
        position: "ne",
        labelFormatter: function (label, series) {
          var percent = Math.round(series.percent);
          var number = series.data[0][1]; //kinda weird, but this is what it takes
          return (
            "&nbsp;<b>" + label + "</b>:&nbsp;" + percent + "% (" + number + ")"
          );
        },
      },
    });
  };

  const today = DateService.convertDateToString(new Date());

  return (
    <>
      <div className={"wrapper wrapper-content box-container"}>
        {isLoading && <Loader />}
        <div className="row">
          <div className="col-12 col-lg-3">
            <div className="ibox ">
              <div className="ibox-title bg-warning">
                <h5>
                  <i className="fa fa-clock-o"></i> รอรับงาน
                </h5>
              </div>
              <div className="ibox-content text-center">
                <h1 className="no-margins">
                  {NumberService.convertToMoney(data.status.waiting)}
                </h1>
                <small>Jobs</small>
                <br />
                <JobStatusComponent value={JOB_STATUS.WAITING} />
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-3">
            <div className="ibox ">
              <div className="ibox-title bg-success">
                <h5 className="">
                  <i className="fa fa-cogs"></i> กำลังดำเนินงาน
                </h5>
              </div>
              <div className="ibox-content text-center">
                <h1 className="no-margins">
                  {NumberService.convertToMoney(data.status.processing)}
                </h1>
                <div className="stat-percent font-bold text-info"></div>
                <small>Jobs</small>
                <br />
                <JobStatusComponent value={JOB_STATUS.PROCESSING} />
                &nbsp;
                <JobStatusComponent value={JOB_STATUS.AUTHENING} />
                &nbsp;
                <JobStatusComponent value={JOB_STATUS.REJECT} />
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-3">
            <div className="ibox ">
              <div className="ibox-title bg-primary">
                <h5 className="">
                  <i className="fa fa-check-circle"></i> รอปิดงาน
                </h5>
              </div>
              <div className="ibox-content text-center">
                <h1 className="no-margins">
                  {NumberService.convertToMoney(data.status.done)}
                </h1>
                <div className="stat-percent font-bold text-info"></div>
                <small>Jobs</small>
                <br />
                <JobStatusComponent value={JOB_STATUS.DONE} />
              </div>
            </div>
          </div>

          <div className="col-12 col-lg-3">
            <div className="ibox ">
              <div className="ibox-title bg-secondary text-white">
                <h5 className="">
                  <i className="fa fa-check-circle"></i> ปิดงานแล้ว
                </h5>
              </div>
              <div className="ibox-content text-center">
                <h1 className="no-margins">
                  {NumberService.convertToMoney(data.status.complete)}
                </h1>
                <div className="stat-percent font-bold text-info"></div>
                <small>Jobs</small>
                <br />
                <JobStatusComponent value={JOB_STATUS.COMPLETE} />
              </div>
            </div>
          </div>
        </div>
        {/* <div className="row">
          <div className="col-lg-12">
            <div className="ibox ">
              <div className="ibox-title">
                <h5>Job per day</h5>
                <div className="ibox-tools"></div>
              </div>
              <div className="ibox-content">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="flot-chart">
                      <div
                        className="flot-chart-content"
                        id="flot-dashboard-chart"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="row">
          <div className="col-lg-12 col-12">
            <div className="ibox ">
              <div className="ibox-title">
                <h5>Status</h5>
              </div>
              <div className="ibox-content">
                <div className="flot-chart">
                  <div className="flot-chart-content" id="flot-pie-chart"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Dashboard;
